// extracted by mini-css-extract-plugin
export default {"modal":"Fl7IUVrFado4McCoEqzP","content":"tFZtZ8p1m00c9PH_RkiH","head":"J_91MDqeo4gM97OH0eMT","body":"rn1MvGGfpB4r8Af11Ip0"};